export default __webpack_public_path__ + "static/unmastered_example2-3734680cf1fbb2184d0a689b56f92740.mp3";